export default __webpack_public_path__ + "static/media/Q9_4_resized.00305b7f.jpg";